import linkifyHtml from 'linkify-html'

export const linkifyUrl = (str: string) => {
  return linkifyHtml(str, {
    validate: {
      // プロトコル部なしのテキストをリンク化しない
      url: value => /^https?:\/\//.test(value),
      email: false,
    },
    target: '_blank',
    rel: 'norefferer noopener',
  })
}
